import actions from './actions'

const initialState = {
  refreshIndex: false,
  results: [],
  data: [],
  maxSize: 0,
  totalSize: 0,
  count: 0,
  loading: false,
  next: null,
  previous: null,
  current: 1,
  limit: 10,
  lastViewedFile: null,
  categories: [],
}

export default function mobyDocReducer(state = initialState, { type, payload }) {
  switch (type) {
    case actions.LOADING_STATUS:
      return {
        ...state,
        loading: payload.loading,
      }
    case actions.RESET_STATE:
      return initialState
    case actions.FILE_DELETED:
      return {
        ...state,
        data: payload.files,
        count: payload.count,
        totalSize: payload.totalSize,
        refreshIndex: payload.refreshIndex,
      }
    case actions.UPDATE_RESULTS:
      return {
        ...state,
        // results: payload.results,
        // TODO maybe comment data
        data: payload.results,
      }
    case actions.UPLOADED_FILE:
      return {
        ...state,
        data: [...state.data, payload.file],
        totalSize: payload.totalSize,
        count: payload.count,
      }
    case actions.REFRESH_INDEX:
      return {
        ...state,
        refreshIndex: payload.refreshIndex,
      }
    case actions.LOAD_ALL_FILES:
      return {
        ...state,
        data: payload.files,
        maxSize: payload.maxSize,
        totalSize: payload.totalSize,
        count: payload.count,
        previous: payload.previous,
        next: payload.next,
        current: payload.current,
        limit: payload.limit,
      }
    case actions.LOAD_FILE_BY_ID:
      return {
        ...state,
        lastViewedFile: payload.file,
      }
    case actions.UPDATE_FILE_REDUCER:
      console.log('In the reducer')
      return {
        ...state,
        data: state.data.map(file =>
          file._id === payload.file._id ? { ...file, ...payload.file } : file,
        ),
      }
    case actions.UPDATE_CATEGORY:
      return {
        ...state,
        data: [
          // return all files that have noting to do with the current file
          // eslint-disable-next-line no-underscore-dangle
          ...state.data.filter(file => file._id !== payload.fileId),
          {
            // inside the current file we want all the other parameters
            // eslint-disable-next-line no-underscore-dangle
            ...state.data.find(file => file._id === payload.fileId),
            // and we only want to edit the categories of this file
            category: payload.category,
          },
        ],
      }
    case actions.UPDATE_TAG:
      return {
        ...state,
        data: [
          // return all files that have noting to do with the current file
          // eslint-disable-next-line no-underscore-dangle
          ...state.data.filter(file => file._id !== payload.fileId),
          {
            // inside the current file we want all the other parameters
            // eslint-disable-next-line no-underscore-dangle
            ...state.data.find(file => file._id === payload.fileId),
            // and we only want to edit the categories of this file
            tags: payload.tags,
          },
        ],
      }
    case actions.CATEGORIES:
      return {
        ...state,
        categories: payload.categories,
      }
    default:
      return state
  }
}
